@if (inEditMode) {
	<mat-form-field
		class="simAdminSettingsInputFieldUnchanged inTableSettingsFormField"
		color="accent"
		[@zoomInOnEnter]
		[class.noLabel]="!labelText"
		appStopPropagation
	>
		<mat-label>{{ labelText }}</mat-label>
		<!-- [(ngModel)] needs to be desugared here because we would otherwise override the first desugared (ngModelChange) -->
		<input
			matInput
			[placeholder]="labelText"
			[type]="type"
			[step]="step"
			(keyup.enter)="enterPressedEmitter.emit()"
			[ngModel]="value"
			(ngModelChange)="onModelChange($event)"
			[required]="required"
		/>
	</mat-form-field>
}
@if (!inEditMode) {
	<div class="inTableSettingsViewValue" [class.noLabel]="!labelText" [@flyInOut]="canAnimate">
		<div
			class="value {{ !wrapText ? 'showDotsOnOverflow' + overflowAfterLines : '' }}"
			[class.wihtoutLineBreak]="!wrapText"
			[class.textAlignCenter]="textCentered"
		>
			@if (templateRef) {
				<ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: value}" />
			}
			@if (!templateRef) {
				@if (type === "password") {
					{{ hashPassword(value) }}
				}
				@if (type !== "password") {
					{{ value }}
				}
			}
		</div>
		@if (showCopyBtn) {
			<button
				class="copyIcon"
				mat-icon-button
				[matTooltip]="T.SHARED_COPY_VALUE_TOOLTIP | translate"
				matTooltipClass="accent"
				color="accent"
				(click)="copyValue(value)"
				appStopPropagation
			>
				<mat-icon fontSet="fad" fontIcon="fa-clipboard" />
			</button>
		}
	</div>
}
